import React, { useState } from 'react';
import { clearAccessToken } from '../helpers/AuthStatus';
import { useNavigate } from 'react-router-dom';
import { getUserDetailsInLocalStorage } from '../helpers/UserDetails';
import { FaUser } from "react-icons/fa";

const AppBar = () => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const handleProfileClick = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const handleLogout = () => {
        clearAccessToken();
        navigate('/');
    };

    const { userName } = getUserDetailsInLocalStorage() || {};

    return (
        <header className="bg-gray-100 rounded-lg shadow-sm">
            <div className="container flex items-center justify-between px-4 py-3 mx-auto">
                {/* Search Bar (Optional - keeping it here in case you want it back) */}
                {/* You can re-enable the search bar by uncommenting this section */}
                {/* <div className="flex items-center w-full max-w-lg px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                        stroke="currentColor"
                        className="w-5 h-5 text-gray-500"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M11 19a8 8 0 100-16 8 8 0 000 16zm-2-8h4m-2-2v4"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search (Ctrl+/)"
                        className="flex-grow ml-3 text-sm text-gray-600 bg-transparent focus:outline-none"
                    />
                </div> */}

                {/* Placeholder for other items on the left (if any) */}
                <div>
                  {/* You can add your logo or other items here */}
                </div>

                {/* User Profile - Moved to the right side */}
                <div className="relative">
                    <div
                        className="flex items-center space-x-3 cursor-pointer"
                        onClick={handleProfileClick}
                    >
                        <div className="text-right">
                            <p className="text-sm font-medium text-gray-800">{userName}</p>
                            <p className="text-xs text-gray-500">Admin</p>
                        </div>
                        <div className="relative">
                            {/* <img
                                src="https://via.placeholder.com/40" // Replace with actual user image URL
                                alt="User"
                                className="w-10 h-10 border-2 border-green-500 rounded-full"
                            /> */}
                            <div className='w-10 h-10 border-2 border-green-500 rounded-full flex items-center justify-center'>
                                <FaUser className='size-6'/>
                            </div>
                            <span className="absolute bottom-0 right-0 w-2.5 h-2.5 bg-green-500 border-2 border-white rounded-full"></span>
                        </div>
                    </div>

                    {/* Dropdown Menu */}
                    {isMenuOpen && (
                        <div className="absolute right-0 z-10 w-48 py-2 mt-2 bg-white rounded-lg shadow-lg">
                            <button
                                onClick={handleLogout}
                                className="block w-full px-4 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                            >
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};

export default AppBar;



